<template>
	<div
		:class="[
			'booking-tooltip',
			size == 'small' ? 'booking-tooltip--small' : ''
		]"
		v-click-outside="{
			exclude: ['button'],
			handler: 'onClose'
		}"
	>
		<button
			ref="button"
			@click="
				() => {
					this.show = !this.show
				}
			"
		>
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M11 10h2v8h-2z"/><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"/><path d="M11 6h2v2h-2z"/></svg>
		</button>
		<div
			v-if="this.show === true"
			class="booking-tooltip__description"
			v-bind:class="{ 'tooltip__description--dark': darkTheme }"
		>
			<h4>{{ title }}</h4>
			<template>
				<p v-for="(paragraph, index) in text" :key="index">
					{{ paragraph }}
				</p>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Tooltip',
	data() {
		return {
			show: false
		}
	},
	props: {
		title: {
			type: String
		},
		text: {
			type: Array
		},
		darkTheme: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: ''
		}
	},
	methods: {
		onClose() {
			this.show = false
		}
	}
}
</script>

<style scoped lang="scss">
.booking-tooltip {
	position: relative;
	line-height: 0;
	margin-left: 6px;
	button {
		cursor: pointer !important;
		border: none;
		background-color: transparent;
		padding: 0;
		line-height: 0;

		> svg {
			width: 18px;
			height: 18px;
			fill: $colorPrimary6;
			vertical-align: unset;
			&:focus {
				outline: none;
			}
			@include for-tablet-landscape-up {
				width: 20px;
				height: 20px;
			}
		}
	}

	&__description {
		max-width: 220px;
		min-width: 220px;
		max-height: 300px;
		overflow: auto;
		padding: 20px 20px 10px 20px;
		background-color: $colorWhite;
		position: absolute;
		top: 35px;
		left: 0;
		z-index: 30;
		box-shadow: 6px 9px 20px -7px rgba(161, 161, 161, 1);

		h4 {
			font-size: 15px;
			margin-bottom: 10px;
		}

		p {
			font-size: 12px;
			margin-bottom: 10px;
		}

		&:before {
			content: '';
			width: 0;
			height: 0;
			border-left: 10px solid transparent;
			border-right: 10px solid transparent;
			border-bottom: 14px solid $colorWhite;
			position: absolute;
			top: -14px;
			left: 0;
			z-index: 30;
		}

		&--dark {
			background-color: $colorGrey1;

			&:before {
				border-bottom: 14px solid $colorGrey1;
			}
		}
	}

	&--small {
		font-size: 0;
		line-height: 1;
		margin-left: 7px;
		button {
			font-size: 0;
			line-height: 1;
			> svg {
				width: 18px;
				height: 18px;
			}
		}
	}

	@include for-tablet-landscape-up {
		&__description {
			top: 0;
			left: 40px;
			min-width: 400px;
			max-width: none;
			padding: 40px 40px 30px 40px;

			h4 {
				font-size: 22px;
			}

			p {
				font-size: 14px;
			}

			&:before {
				top: 3px;
				left: -17px;
				transform: rotate(-90deg);
			}
		}
	}
}
</style>
